export const NAME_VALIDATION_REGEX = /^[a-zA-Z\s._'-]+$/;
export const POSTCODE_VALIDATION_REGEX = /^[a-zA-Z0-9]+$/;
export const MEMBERSHIP_VALIDATION_REGEX = /^[a-zA-Z0-9]+$/;
export const UPPER_CASE_REGEX = /[A-Z]/;
export const LOWER_CASE_REGEX = /[a-z]/;
export const SPECIAL_CHARACTER_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
export const NUMBER_REGEX = /[0-9]/;
export const NO_SPACE_REGEX = /^\S*$/;
export const PRE_AUTH_CODE_REGEX = /^[0-9]+$/;
